import React from "react";
import {Input} from "reactstrap";

/**
 *
 * User : 이연우
 * Date : 2023.05.31
 * @ file : Components/Common/CpmCommInputSelect.js
 * @ Desc : input type=Select 컴포넌트
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {Array<object>} selectOptions - 데이터 [{label: string, value: any}]
 * @param {object} params - 부모 컴포넌트로부터 받아온 파라미터 객체
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {string} label - 라벨
 * @param {boolean} essential - 필수 여부
 * @param {string} placeholder - placeholder
 * @param {boolean} isDisabled - disabled Yn
*/

const CpmCommInputSelect = ({
    id, 
    selectOptions = [],
    params, 
    setParams, 
    label,
    essential = false,
    placeholder,
    isDisabled,
    allOtption = false,
    selectOtption = false,
    onChangeInputSelect = () => {},
}) => {
    const paramNm = id || 'select'

    const onChangeHandle = (e) => {
        setParams({[paramNm]: e.target.value});
        onChangeInputSelect(e) ;
    };
    return (
        <>
            <div className='d-flex align-items-center' >
            <Input
                id={id}
                name={label || paramNm}
                type="select"
                bsSize="sm"
                className={`${essential && 'essential'} form-control-sm`}
                onChange={onChangeHandle}
                placeholder={placeholder}
                disabled={isDisabled}
                value={params[paramNm]}
            >
                {allOtption && (
                    <option  value="%"> 전체 </option>
                )}
                {selectOtption && (
                    <option  value=""> 선택 </option>
                )}
                {selectOptions.map(( el , idx ) => {
                    return (
                        <option key={`Options_${idx}`} value={el.value}>
                            {el.label}
                        </option>
                    );
                })}
            </Input>
            </div>
        </>
    );
};

export default CpmCommInputSelect;
